<!-- Header -->
<app-details-page-header
  [title]="companyTypeSignal()?.code ?? ''"
  [id]="companyTypeId ?? ''"
  (back)="goBack()"
>
  <button
    class="btn btn-falcon-default btn-sm d-flex align-items-center gap-2"
    type="button"
    (click)="deleteCompanyType()"
  >
    <i class="fas fa-trash-alt"></i> {{ "general.remove" | translate }}
  </button>
</app-details-page-header>

<!-- Main content -->

<div class="card card-details shadow-sm border-0 py-2">
  <ul class="nav nav-tabs mb-2" role="tablist">
    <li class="nav-item" *ngFor="let tab of tabs" role="presentation">
      <a
        class="nav-link"
        [class.active]="activeTab === tab.key"
        role="tab"
        [attr.aria-controls]="tab.key"
        [attr.aria-selected]="activeTab === tab.key"
        (click)="setTab(tab.key)"
      >
        {{ tab.label | translate }}
      </a>
    </li>
  </ul>

  <div class="tab-content">
    <div
      class="tab-pane fade m-2"
      [class.show]="activeTab === 'details'"
      [class.active]="activeTab === 'details'"
      id="entities"
      role="tabpanel"
    >
      <app-details-tab
        [showButtons]="true"
        [disableCodeInput]="true"
        [formGroupInput]="companyTypeFormGroup.controls.details"
        [disableSave]="companyTypeFormGroup.invalid"
        (emitSave)="saveCompanyType()"
        (emitCancel)="goBack()"
      ></app-details-tab>
    </div>
    <div
      class="tab-pane fade m-2"
      [class.show]="activeTab === 'localizations'"
      [class.active]="activeTab === 'localizations'"
      id="localizations"
      role="tabpanel"
    >
      <app-localization-tab
        [showButtons]="true"
        [formGroupInput]="companyTypeFormGroup.controls.localizationsTab"
        [disableSave]="companyTypeFormGroup.invalid"
        (emitSave)="saveCompanyType()"
        (emitCancel)="goBack()"
      ></app-localization-tab>
    </div>

    <div
      class="tab-pane fade m-2"
      [class.show]="activeTab === 'countriesUsed'"
      [class.active]="activeTab === 'countriesUsed'"
      id="countriesUsed"
      role="tabpanel"
    >
      <app-countries-used-tab
        [showButtons]="true"
        [countriesUsed]="countriesUsedList"
        [rootForm]="companyTypeFormGroup.controls.countriesUsed"
        [disableSave]="companyTypeFormGroup.invalid"
        (emitSave)="saveCompanyType()"
        (emitCancel)="goBack()"
      ></app-countries-used-tab>
    </div>
  </div>
</div>
